'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Wifi = function Wifi(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? '24' : _ref$size,
      otherProps = _objectWithoutProperties(_ref, ['color', 'size']);

  return (0, _preact.h)(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: color,
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round'
    }, otherProps),
    (0, _preact.h)('path', { d: 'M5 12.55a11 11 0 0 1 14.08 0' }),
    (0, _preact.h)('path', { d: 'M1.42 9a16 16 0 0 1 21.16 0' }),
    (0, _preact.h)('path', { d: 'M8.53 16.11a6 6 0 0 1 6.95 0' }),
    (0, _preact.h)('line', { x1: '12', y1: '20', x2: '12', y2: '20' })
  );
};

exports.default = Wifi;